import { render, staticRenderFns } from "./formatsize.vue?vue&type=template&id=34d88458&scoped=true&"
import script from "./formatsize.vue?vue&type=script&lang=js&"
export * from "./formatsize.vue?vue&type=script&lang=js&"
import style0 from "./formatsize.vue?vue&type=style&index=0&id=34d88458&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34d88458",
  null
  
)

export default component.exports